<app-nav-header></app-nav-header>
<app-sidebar-menu></app-sidebar-menu>
<ngx-loading [show]="loading"> </ngx-loading>
<div class="page-content-wrapper">
  <div class="page-content">
    <div class="page-bar">
      <div class="page-title-breadcrumb">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="page-title">Notificação</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-topline-green">
            <div class="card-body">
              <div class="table-responsive table-mobile">
                <table class="table table-striped custom-table table-hover">
                  <thead>
                    <tr>
                      <th>Mensagem</th>
                      <th>Data de criação</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let notification of notifications.results">
                      <td>{{ notification.description }}</td>
                      <td>
                        {{ notification.createdAt | date : "dd/MM/yyyy" }}
                      </td>
                      <td>
                        <span
                          *ngIf="!notification.read"
                          (click)="setRead(notification.id)"
                          class="label label-sucess label-mini"
                          >Marcar como Lida</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div class="col-md-12">
                    <span
                      *ngIf="!notifications?.results?.length"
                      class="label label-danger label-mini"
                      >Nenhuma notificação encontrada.</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer" *ngIf="notifications">
              <app-pagination
                [pagination]="notifications"
                (pageChange)="onSearch($event)"
                (perPageChange)="onPerPageChanged($event)"
              ></app-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
